/**
 * RC-WEB-6 PHASE 10 — the active navigation section is DERIVED from the real
 * normalized route (including nested routes), never from manual state.
 */

const SECTIONS = [
  { key: "overview", to: "/dashboard", test: (p) => p === "/dashboard" },
  {
    key: "protections",
    to: "/dashboard/vehicles",
    test: (p) =>
      p.startsWith("/dashboard/vehicles") ||
      p.startsWith("/vehicle/") ||
      p.startsWith("/new-protection") ||
      p.startsWith("/debug/qr-flow"),
  },
  { key: "messages", to: "/mensajes", test: (p) => p.startsWith("/mensajes") },
  { key: "calls", to: "/llamadas", test: (p) => p.startsWith("/llamadas") },
  {
    key: "trusted",
    to: "/contactos-de-confianza",
    test: (p) => p.startsWith("/contactos-de-confianza") || p.startsWith("/dashboard/contactos-de-confianza"),
  },
  { key: "sticker", to: "/sticker-studio", test: (p) => p.startsWith("/sticker-studio") },
  {
    key: "membership",
    to: "/renovar",
    test: (p) => p.startsWith("/renovar") || p.startsWith("/checkout"),
  },
  {
    key: "settings",
    to: "/settings",
    test: (p) => p.startsWith("/settings") || p.startsWith("/dashboard/profile"),
  },
];

const normalize = (pathname) => {
  const p = (pathname || "/").split("?")[0].split("#")[0];
  return p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p;
};

export const activeSectionKey = (pathname) => {
  const p = normalize(pathname);
  const hit = SECTIONS.find((s) => s.test(p));
  return hit ? hit.key : null;
};

export const isSectionActive = (pathname, to) => {
  const key = activeSectionKey(pathname);
  if (!key) return false;
  const section = SECTIONS.find((s) => s.key === key);
  return !!section && section.to === to;
};

export default SECTIONS;
